import { render, staticRenderFns } from "./ghInvoke.vue?vue&type=template&id=e720a91e&scoped=true&"
import script from "./ghInvoke.vue?vue&type=script&lang=js&"
export * from "./ghInvoke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e720a91e",
  null
  
)

export default component.exports